// Three-band reduction (bass/mids/treble) plus mids split (lowMids/highMids)
// over a WebAudio AnalyserNode-like. Allocates the byte buffer once; reuses
// it on every read() call. M6 added lowMids [20,30) + highMids [30,40) for
// the fractal's separate camera-orbit (lowMids) vs palette-shift (highMids)
// channels; keeping `mids` over [20,40) for back-compat with M4 cathedral.
export class BandAnalyser {
  constructor(analyserLike) {
    this.analyser = analyserLike;
    this.raw = new Uint8Array(analyserLike.frequencyBinCount);
  }

  read() {
    this.analyser.getByteFrequencyData(this.raw);
    const raw = this.raw;
    let bSum = 0;
    for (let i = 0; i < 8; i++) bSum += raw[i];
    let lmSum = 0;
    for (let i = 20; i < 30; i++) lmSum += raw[i];
    let hmSum = 0;
    for (let i = 30; i < 40; i++) hmSum += raw[i];
    let tSum = 0;
    for (let i = 60; i < 128; i++) tSum += raw[i];
    const mSum = lmSum + hmSum;
    return {
      bass: bSum / (8 * 255),
      mids: mSum / (20 * 255),
      lowMids: lmSum / (10 * 255),
      highMids: hmSum / (10 * 255),
      treble: tSum / (68 * 255),
      raw,
    };
  }
}
